import type { FC } from 'react';
import Loading from '@/components/Loading';

const LoadingMain: FC = () => {
  return (
    <main className="App-MainContent">
      <Loading />
    </main>
  );
};

export default LoadingMain;
